export default {
  rights: [
    'edit',
    'delete'
  ],
  resource:{
    zh: {
      tbjl: "工号",
      xm: "姓名",
      bh: "编号",
      bm: "部门",
      fingerCount: "指纹数量",
      flag: "用户类型",
      userM: "普通用户",
      userS: "超级用户",
      bya: "上传状态",
      uload1: "已上传",
      uload2: "未上传",
      ickh:"磁卡号"
    }
    ,en: {
      tbjl: "Employee No.",
      xm: "Name",
      bh: "Number",
      bm: "Dept.",
      fingerCount: "Fingerprint",
      flag: "User Type",
      userM: "Ordinary user",
      userS: "Admin",
      bya: "Status",
      uload1: "Already",
      uload2: "Not Yet"
    }

  },
  params: {
    xm:{
      key: "xm",
      data: null,
      method: "Contains",
      title: "姓名",
      type: "text"
    },
    bh:{
      key: "bh",
      data: null,
      method: "Equal",
      title: "编号",
      type: "text"
    }
  },
  listDefine: [{
      title: "查看",
      key: "viewClumn",
      type: "viewClumn",
      keys: ["bh"],
      width: 100
    },
    {
      title: "编辑",
      key: "editClumn",
      type: "editClumn",
      keys: ["bh"],
      width: 100,
      right: "edit"
    },
    {
      title: "删除",
      key: "deleteClumn",
      type: "deleteClumn",
      keys: ["bh"],
      width: 100,
      right: "delete"
    },
    {
      title: "工号",
      type: "sortClumn",
      key: "bh",
      skey: "bh",
      width: 100
    },
    {
      title: "姓名",
      type: "sortClumn",
      key: "xm",
      skey: "xm",
      width: 100
    },
    {
      title: "部门",
      type: "sortClumn",
      key: "bm",
      skey: "bm",
      width: 100
    },
    {
      title: "指纹数量",
      type: "sortClumn",
      key: "fingerCount",
      skey: "fingerCount",
      width: 100
    },
    "ickh",
    {
      title: "用户类型",
      type: "sortClumn",
      key: "flag",
      skey: "flag",
      width: 120,
      formatter: "userType"
    },
    {
      title: "上传状态",
      type: "sortClumn",
      key: "bya",
      skey: "bya",
      width: 100,
      formatter: "updateLoadType"
    }
  ],
  formatter: {
    userType(t) {
      if (t == 0) return "userM";
      else if (t == 3) return "userS";
      else return t;
    },
    updateLoadType(t) {
      if (t == 1) return "uload1";
      else return "uload2";
    }
  },
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  sortName: "bh",
  sortOrder: "asc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "card/"

}
